import { z } from 'zod';
import { documentSchema } from './IDocument';

export const LegalTransactionGwGEntrySchema = z.object({
  idLegalTransactionGwGEntry: z.number(),
  idLegalTransactionGwG: z.number(),
  isPaid: z.boolean(),
  wasPaid: z.boolean(),
  currentValue: z.number(),
  currentRate: z.number().nullable(),
  extraCosts: z.number().nullable(),
  title: z.string().nullable(),
  DocumentArray: z.array(documentSchema),

  // 1=Prüfung, 2=Geprüft, 3=Abgelehnt
  idLegalTransactionGwGEntryState: z.number(),

  mailSubject: z.string().nullable().optional(),
  mailBody: z.string().nullable().optional(),
});

export type ILegalTransactionGwGEntry = z.infer<
  typeof LegalTransactionGwGEntrySchema
>;

export const createNewGwGEntry = (
  isPaid: boolean,
  gwgId: number,
  nextTempId: number
): ILegalTransactionGwGEntry => ({
  idLegalTransactionGwGEntry: nextTempId,
  idLegalTransactionGwG: gwgId,
  currentValue: 0,
  isPaid,
  wasPaid: isPaid,
  title: '',
  currentRate: isPaid ? null : 0,
  extraCosts: isPaid ? null : 0,
  DocumentArray: [],
  idLegalTransactionGwGEntryState: 2,
});
